export default "__VITE_ASSET__48c1767b__"